import React from 'react';
import styled, { css } from 'styled-components';

import { ButtonGroup, Label, mediaMixin, Spacer, Text, ToggleButton } from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import type { HTMLElementEvent } from '../../../../models/Types';
import { SNOW_REMOVAL } from '../../../../constants';

const StyledShowForSmall = styled.div`
  && {
    display: initial;
    ${mediaMixin(
      'md',
      css`
        display: none;
      `,
    )}
  }
`;

const StyledHideForSmall = styled.div`
  && {
    display: none;
    ${mediaMixin(
      'md',
      css`
        display: initial;
      `,
    )}
  }
`;

type Props = {
  setButtonGroupClick: (fieldName: string, buttonValue: string) => void;
  areaName?: string;
  fieldName: string;
  buttonValue: string;
  twoButtonArea?: boolean;
};

export default function AreaButtonGroup_v2({
  setButtonGroupClick,
  areaName,
  fieldName,
  buttonValue,
  twoButtonArea,
}: Props): JSX.Element {
  function onButtonClick(event: HTMLElementEvent<typeof ToggleButton>): void {
    const { value } = event.currentTarget.dataset;
    setButtonGroupClick(fieldName, value);
  }
  return (
    <Spacer marginBottom="sm">
      {twoButtonArea ? (
        <>
          <Label>Who will be responsible for this area?</Label>
          <Spacer marginTop="xs" />
          <ButtonGroup conjoined fluid aria-label="snow removal responsibility">
            <ToggleButton
              pressed={buttonValue === SNOW_REMOVAL.LANDLORD}
              data-value={SNOW_REMOVAL.LANDLORD}
              data-test="AreaButtonGroup-landlord"
              onClick={onButtonClick}
            >
              Landlord
            </ToggleButton>
            <ToggleButton
              pressed={buttonValue === SNOW_REMOVAL.TENANT}
              data-value={SNOW_REMOVAL.TENANT}
              onClick={onButtonClick}
            >
              Tenant
            </ToggleButton>
          </ButtonGroup>
        </>
      ) : (
        <>
          <StyledShowForSmall>
            <Text fontType="bodySmall">{areaName}</Text>
            <ButtonGroup conjoined fluid aria-label="snow removal responsibility">
              <ToggleButton
                pressed={buttonValue === SNOW_REMOVAL.LANDLORD}
                data-value={SNOW_REMOVAL.LANDLORD}
                data-test="AreaButtonGroup-landlord"
                onClick={onButtonClick}
              >
                Landlord
              </ToggleButton>
              <ToggleButton
                pressed={buttonValue === SNOW_REMOVAL.TENANT}
                data-value={SNOW_REMOVAL.TENANT}
                onClick={onButtonClick}
              >
                Tenant
              </ToggleButton>
              <ToggleButton
                pressed={buttonValue === SNOW_REMOVAL.NA}
                data-value={SNOW_REMOVAL.NA}
                onClick={onButtonClick}
              >
                N/A
              </ToggleButton>
            </ButtonGroup>
          </StyledShowForSmall>
          <StyledHideForSmall>
            <Row>
              <Col xs={0} sm={5}>
                <Text fontType="bodySmall">{areaName}</Text>
              </Col>
              <Col xs={0} sm={7}>
                <ButtonGroup conjoined fluid aria-label="snow removal responsibility">
                  <ToggleButton
                    pressed={buttonValue === SNOW_REMOVAL.LANDLORD}
                    data-value={SNOW_REMOVAL.LANDLORD}
                    data-test="AreaButtonGroup-landlord"
                    onClick={onButtonClick}
                  >
                    Landlord
                  </ToggleButton>
                  <ToggleButton
                    pressed={buttonValue === SNOW_REMOVAL.TENANT}
                    data-value={SNOW_REMOVAL.TENANT}
                    onClick={onButtonClick}
                  >
                    Tenant
                  </ToggleButton>
                  <ToggleButton
                    pressed={buttonValue === SNOW_REMOVAL.NA}
                    data-value={SNOW_REMOVAL.NA}
                    onClick={onButtonClick}
                  >
                    N/A
                  </ToggleButton>
                </ButtonGroup>
              </Col>
            </Row>
          </StyledHideForSmall>
        </>
      )}
    </Spacer>
  );
}
